<template>
  <div>
    <div class="tb-form-group">
      <label class="tb-label">
        Image
      </label>

      <template v-if="!isDataMapped">
        <div v-if="element.imageUrl" class="media-upload-wrapper">
          <div class="media" :style="{ 'background-image' : 'url(' + element.imageUrl + ')' }"></div>

          <div class="edit-media">
            <button
              class="tb-btn tb-btn-contained on-image"
              data-entity="producer-editor-editBackgroundImage"
              data-test="graphics-editor-image-select"
              @click="selectAsset"
            >
              <span class="fas fa-pencil-alt"></span>
            </button>
          </div>
        </div>

        <button
          v-else
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-editor-selectBackgroundImage"
          data-test="graphics-editor-image-select"
          @click="selectAsset"
        >
          <span class="fas fa-image mr-1"></span>
          Choose image
        </button>
      </template>

      <div v-else class="text-em" data-test="graphics-editor-imageMapping">
        {{ mappingLabel }}
      </div>
    </div>

    <div v-if="showFillType" class="tb-form-group">
      <label class="tb-label">Fill type</label>

      <select
        class="tb-select"
        data-entity="producer-editor-selectFillType"
        data-test="graphics-editor-image-fillDropdown"
        v-model="fillType"
      >
        <option value="stretch">Stretch</option>
        <option value="fit">Fit</option>
        <option value="fill">Fill</option>
      </select>
    </div>
  </div>
</template>

<script>
import {get} from 'lodash-es';

export default {
  props: ['element', 'graphic_fields'],

  methods: {
    selectAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'image' });

      window.assetmanfn = (asset, meta = {}) => {
        this.element.imageUrl = asset.media_url; // eslint-disable-line
        this.element.imageMeta = meta; // eslint-disable-line
        this.$emit('value', { value: asset.media_url, field: 'imageUrl' });
        this.$emit('value', { value: meta, field: 'imageMeta' });
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'image' });
      };
    },
  },

  computed: {
    isMarqueeImage() {
      return this.element.type === 'marquee-image';
    },
    showFillType() {
      return !this.isMarqueeImage && !this.element.mask;
    },
    fields() {
      return this.graphic_fields[this.element.id] ?? {};
    },

    fillType: {
      get() {
        return this.fields.fillType ?? this.element.fillType ?? 'stretch';
      },

      set(value) {
        this.$emit('value', {
          field: 'fillType',
          value,
        });
      },
    },

    isDataMapped() {
      return !!get(this.element, 'data.provider');
    },

    mappingLabel() {
      if (!this.isDataMapped) {
        return '';
      }

      return 'Field mapped to data';
    },
  },
};
</script>
